import { create } from "zustand";

export type FeatureFlagValue = boolean | string | string[];
export interface FeatureFlags {
  [key: string]: FeatureFlagValue;
}

interface FeatureFlagState {
  flags: FeatureFlags;
  setFlags: (f: FeatureFlags) => void;
}

export const useFeatureFlagStore = create<FeatureFlagState>((set) => ({
  flags: {},
  setFlags: (f) => set({ flags: f || {} }),
}));
